import React, { useState, useEffect } from 'react';
import { Dialog } from 'primereact/dialog';
import { Button } from 'primereact/button';
import { InputText } from 'primereact/inputtext';
import { Calendar } from 'primereact/calendar';
import { Dropdown } from 'primereact/dropdown';
import { Message } from 'primereact/message';
import { ProgressSpinner } from 'primereact/progressspinner';
import axios from 'axios';
import { toast, ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

function EnquiryModal({ selectedEnquiry, handleCloseAssignModal, onUpdateSuccess,statusCancelled }) {

  const [formData, setFormData] = useState({
    address: '',
    city: '',
    state: '',
    scheduleDate: null,
    scheduleTime: '',
    phleboId: '',
    pincode: ''
  });
  
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [success, setSuccess] = useState(null);
  const [phleboLoading, setPhleboLoading] = useState(false);
  const [phleboList, setPhleboList] = useState([]);
  const [addressLoading, setAddressLoading] = useState(false);
  const [areaOptions, setAreaOptions] = useState([]);
  const [selectedArea, setSelectedArea] = useState(null);

console.log(statusCancelled,"qwerttt")
  // Helper function to parse time string to Date object
  const parseTimeString = (timeStr) => {
    if (!timeStr) return null;
    const [hours, minutes] = timeStr.split(':');
    const date = new Date();
    date.setHours(parseInt(hours), parseInt(minutes), 0, 0);
    return date;
  };

  // Helper function to format time Date object to string
  const formatTimeToString = (timeDate) => {
    if (!timeDate) return '';
    const hours = timeDate.getHours().toString().padStart(2, '0');
    const minutes = timeDate.getMinutes().toString().padStart(2, '0');
    return `${hours}:${minutes}`;
  };

  // State options for India
  const stateOptions = [
    { label: 'Andhra Pradesh', value: 'Andhra Pradesh' },
    { label: 'Arunachal Pradesh', value: 'Arunachal Pradesh' },
    { label: 'Assam', value: 'Assam' },
    { label: 'Bihar', value: 'Bihar' },
    { label: 'Chhattisgarh', value: 'Chhattisgarh' },
    { label: 'Goa', value: 'Goa' },
    { label: 'Gujarat', value: 'Gujarat' },
    { label: 'Haryana', value: 'Haryana' },
    { label: 'Himachal Pradesh', value: 'Himachal Pradesh' },
    { label: 'Jharkhand', value: 'Jharkhand' },
    { label: 'Karnataka', value: 'Karnataka' },
    { label: 'Kerala', value: 'Kerala' },
    { label: 'Madhya Pradesh', value: 'Madhya Pradesh' },
    { label: 'Maharashtra', value: 'Maharashtra' },
    { label: 'Manipur', value: 'Manipur' },
    { label: 'Meghalaya', value: 'Meghalaya' },
    { label: 'Mizoram', value: 'Mizoram' },
    { label: 'Nagaland', value: 'Nagaland' },
    { label: 'Odisha', value: 'Odisha' },
    { label: 'Punjab', value: 'Punjab' },
    { label: 'Rajasthan', value: 'Rajasthan' },
    { label: 'Sikkim', value: 'Sikkim' },
    { label: 'Tamil Nadu', value: 'Tamil Nadu' },
    { label: 'Telangana', value: 'Telangana' },
    { label: 'Tripura', value: 'Tripura' },
    { label: 'Uttar Pradesh', value: 'Uttar Pradesh' },
    { label: 'Uttarakhand', value: 'Uttarakhand' },
    { label: 'West Bengal', value: 'West Bengal' },
    { label: 'Delhi', value: 'Delhi' }
  ];

  // Fetch address details by pincode
  const fetchAddressDetails = async (pincode) => {
    if (!pincode) return;
    
    try {
      setAddressLoading(true);
      const response = await axios.get(
        `${process.env.REACT_APP_COMMON_BASEURL}getAllAddressDetails/list?pincode=${pincode}`
      );

      const data = response.data?.data || [];
      
      if (data.length > 0) {
        const formattedOptions = data.map((item) => ({
          label: `${item.area} - ${item.block}, ${item.district}`,
          value: item,
          area: item.area,
          state: item.state,
          district: item.district,
          block: item.block,
          lattitude: item.lattitude,
          longitude: item.longitude
        }));
        
        setAreaOptions(formattedOptions);
        
        // If only one option, auto-select it
        if (data.length === 1) {
          handleAreaSelection(formattedOptions[0].value);
          setSelectedArea(formattedOptions[0].value);
        }
      } else {
        setAreaOptions([]);
        setError('No address details found for this pincode');
      }
    } catch (err) {
      console.error('Error fetching address details:', err);
      setError('Failed to fetch address details for this pincode');
      setAreaOptions([]);
    } finally {
      setAddressLoading(false);
    }
  };

  // Handle area selection and auto-fill address details
  const handleAreaSelection = (areaData) => {
    if (areaData) {
      setFormData(prev => ({
        ...prev,
        city: areaData.district || '',
        state: areaData.state || '',
        address: `${areaData.area}, ${areaData.block}, ${areaData.district}` || ''
      }));
      setSelectedArea(areaData);
      
      // Clear any existing errors
      if (error) {
        setError(null);
      }
    }
  };

  const fetchPhleboList = async () => {
    const { orderId, lattitude, longitude } = selectedEnquiry;
    let lat = lattitude || '';
    let long = longitude || '';
    
    // Use coordinates from selected area if available
    if (selectedArea && selectedArea.lattitude && selectedArea.longitude) {
      lat = selectedArea.lattitude;
      long = selectedArea.longitude;
    }
  
    try {
      setPhleboLoading(true);
      const response = await axios.post(
        `${process.env.REACT_APP_PHLEBO_BASEURL}phleboList?lat=${lat}&log=${long}&activeUser=1`,
      );

      const data = response.data?.data || [];

      const formattedList = data.map((item) => ({
        label: `${item.firstName || ""} ${item.lastName || ""} - ${item.mobile || ""}`.trim(),
        value: item.code,
      }));

      setPhleboList(formattedList);
    } catch (err) {
      console.error(err);
    } finally {
      setPhleboLoading(false);
    }
  };

  useEffect(() => {
    if (selectedEnquiry) {
      console.log(selectedEnquiry, "Selected enquiry data");
      
      setFormData({
        address: selectedEnquiry.address || '',
        city: selectedEnquiry.city || '',
        state: selectedEnquiry.state || '',
        scheduleDate: selectedEnquiry.scheduleDate ? new Date(selectedEnquiry.scheduleDate) : null,
        scheduleTime: selectedEnquiry.scheduleTime ? parseTimeString(selectedEnquiry.scheduleTime) : null,
        phleboId: selectedEnquiry.phleboId || '',
        pincode: selectedEnquiry.pincode || ''
      });
      
      // Fetch address details if pincode exists
      if (selectedEnquiry.pincode) {
        fetchAddressDetails(selectedEnquiry.pincode);
      }
      
      // Fetch phlebotomists
      fetchPhleboList();
      
      // Reset messages and area selection
      setError(null);
      setSuccess(null);
      setSelectedArea(null);
      setAreaOptions([]);
    }
  }, [selectedEnquiry]);

  // Refetch phlebotomists when area selection changes (coordinates update)
  useEffect(() => {
    if (selectedArea && selectedArea.lattitude && selectedArea.longitude) {
      fetchPhleboList();
    }
  }, [selectedArea]);

  const handleInputChange = (field, value) => {
    setFormData(prev => ({
      ...prev,
      [field]: value
    }));
    
    // Clear error when user starts typing
    if (error) {
      setError(null);
    }
  };

  const validateForm = () => {
    const errors = [];
    
    if (!formData.address.trim()) {
      errors.push('Address is required');
    }
    
    if (!formData.city.trim()) {
      errors.push('City is required');
    }
    
    if (!formData.state) {
      errors.push('State is required');
    }
    
    if (!formData.scheduleDate) {
      errors.push('Schedule date is required');
    }
    
    if (!formData.scheduleTime) {
      errors.push('Schedule time is required');
    }
    
    if (!formData.phleboId) {
      errors.push('Phlebotomist selection is required');
    }
    
    return errors;
  };

  const handleSubmit = async () => {
    const validationErrors = validateForm();
    
    if (validationErrors.length > 0) {
      setError(validationErrors.join(', '));
      return;
    }

    setLoading(true);
    setError(null);
    setSuccess(null);

    try {
      // Format date for API
      const formattedDate = formData.scheduleDate.toISOString().split('T')[0];
      const formattedTime = formatTimeToString(formData.scheduleTime);
      
      const updateData = {
        address: formData.address.trim(),
        city: formData.city.trim(),
        state: formData.state,
        scheduleDate: formattedDate,
        scheduleTime: formattedTime,
        phleboId: formData.phleboId
        
      };

      console.log('Updating enquiry with data:', updateData);

      const response = await fetch(`${process.env.REACT_APP_PHLEBO_BASEURL}enquiry/updateDetails/${selectedEnquiry.id}`, {
        method: 'PUT',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(updateData)
      });

      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }

      const apiResponse = await response.json();

      if (apiResponse.status) {
          toast.success('Enquiry Updated successfully!', {
                            position: "top-right",
                            autoClose: 3000,
                            hideProgressBar: false,
                            closeOnClick: true,
                            pauseOnHover: true,
                            draggable: true,
                            progress: undefined,
                        });
        
        // Call success callback after a short delay
        setTimeout(() => {
          onUpdateSuccess && onUpdateSuccess(selectedEnquiry, updateData);
          handleClose();
        }, 1500);
      } else {
        throw new Error(apiResponse.message || 'Failed to update enquiry');
      }
    } catch (err) {
      console.error('Update error:', err);
      setError(`Failed to update enquiry: ${err.message}`);
    } finally {
      setLoading(false);
    }
  };

  const handleClose = () => {
    setFormData({
      address: '',
      city: '',
      state: '',
      scheduleDate: null,
      scheduleTime: null,
      phleboId: '',
      pincode: ''
    });
    setError(null);
    setSuccess(null);
    setSelectedArea(null);
    setAreaOptions([]);
    handleCloseAssignModal();
  };

  const dialogFooter = (
    <div style={{ display: 'flex', justifyContent: 'flex-end', gap: '0.5rem' }}>
      <Button
        label="Cancel"
        icon="pi pi-times"
        onClick={handleClose}
        className="p-button-secondary"
        disabled={loading}
      />
      <Button
        label={loading ? 'Updating...' : 'Update Enquiry'}
        icon={loading ? 'pi pi-spin pi-spinner' : 'pi pi-check'}
        onClick={handleSubmit}
        className="p-button-primary"
        disabled={loading}
      />
    </div>
  );

  if (!selectedEnquiry) {
    return null;
  }

  return (
    <>
    <Dialog
      header="Update Enquiry Details"
      visible={!!selectedEnquiry}
      onHide={handleClose}
      footer={dialogFooter}
      style={{ width: '800px', maxWidth: '90vw' }}
      modal
      draggable={false}
      resizable={false}
    >
      <div style={{ padding: '1rem 0' }}>
        {/* Enquiry Information */}
        <div style={{ 
          backgroundColor: '#f8f9fa', 
          padding: '1rem', 
          borderRadius: '0.375rem', 
          marginBottom: '1.5rem' 
        }}>
          <h4 style={{ 
            margin: '0 0 0.75rem 0', 
            color: '#374151', 
            fontSize: '1.125rem',
            fontWeight: '600'
          }}>
            Enquiry Information
          </h4>
          
          <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '1rem' }}>
            <div>
              <strong>Name:</strong> {selectedEnquiry.name || 'N/A'}
            </div>
            <div>
              <strong>Mobile:</strong> {selectedEnquiry.mobile || 'N/A'}
            </div>
            <div>
              <strong>Email:</strong> {selectedEnquiry.email || 'N/A'}
            </div>
            <div>
              <strong>Status:</strong> {
                selectedEnquiry.status === 0 ? 'Unassigned' :
                selectedEnquiry.status === 1 ? 'Assigned' :
                selectedEnquiry.status === 4 ? 'Cancelled' : 'Unknown'
              }
            </div>
          </div>
        </div>

        {/* Error/Success Messages */}
      

        {/* Update Form */}
        <div style={{ display: 'grid', gap: '1.5rem' }}>
          {/* Pincode (Non-editable) */}
          <div>
            <label 
              htmlFor="pincode" 
              style={{ 
                display: 'block', 
                marginBottom: '0.5rem', 
                fontWeight: '500',
                color: '#374151' 
              }}
            >
              Pincode
            </label>
            <InputText
              id="pincode"
              value={formData.pincode}
              placeholder="Pincode not available"
              style={{ 
                width: '100%', 
                backgroundColor: '#f9fafb',
                color: '#6b7280'
              }}
              disabled={true}
              readOnly={true}
            />
          </div>

          {/* Area Selection */}
          {formData.pincode && (
            <div>
              <label 
                htmlFor="area" 
                style={{ 
                  display: 'block', 
                  marginBottom: '0.5rem', 
                  fontWeight: '500',
                  color: '#374151' 
                }}
              >
                Select Area
              </label>
              
              {addressLoading ? (
                <div style={{ 
                  display: 'flex', 
                  alignItems: 'center', 
                  padding: '0.75rem',
                  border: '1px solid #d1d5db',
                  borderRadius: '0.375rem'
                }}>
                  <ProgressSpinner style={{ width: '20px', height: '20px' }} />
                  <span style={{ marginLeft: '0.5rem' }}>Loading areas...</span>
                </div>
              ) : (
                <Dropdown
                  id="area"
                  value={selectedArea}
                  options={areaOptions}
                  onChange={(e) => handleAreaSelection(e.value)}
                  placeholder="Select area to auto-fill address details"
                  style={{ width: '100%' }}
                  disabled={loading || addressLoading}
                  filter
                  filterBy="label"
                  emptyMessage="No areas found for this pincode"
                />
              )}
            </div>
          )}

          {/* Address */}
          <div>
            <label 
              htmlFor="address" 
              style={{ 
                display: 'block', 
                marginBottom: '0.5rem', 
                fontWeight: '500',
                color: '#374151' 
              }}
            >
              Address <span style={{ color: '#ef4444' }}>*</span>
            </label>
            <InputText
              id="address"
              value={formData.address}
              onChange={(e) => handleInputChange('address', e.target.value)}
              placeholder="Enter full address"
              style={{ width: '100%' }}
              disabled={loading}
            />
            {selectedArea && (
              <small style={{ color: '#6b7280', fontSize: '0.75rem' }}>
                Address auto-filled from selected area. You can edit it as needed.
              </small>
            )}
          </div>

          {/* City and State */}
          <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '1rem' }}>
            <div>
              <label 
                htmlFor="city" 
                style={{ 
                  display: 'block', 
                  marginBottom: '0.5rem', 
                  fontWeight: '500',
                  color: '#374151' 
                }}
              >
                City <span style={{ color: '#ef4444' }}>*</span>
              </label>
              <InputText
                id="city"
                value={formData.city}
                onChange={(e) => handleInputChange('city', e.target.value)}
                placeholder="Enter city"
                style={{ width: '100%' }}
                disabled={loading}
              />
            </div>

            <div>
              <label 
                htmlFor="state" 
                style={{ 
                  display: 'block', 
                  marginBottom: '0.5rem', 
                  fontWeight: '500',
                  color: '#374151' 
                }}
              >
                State <span style={{ color: '#ef4444' }}>*</span>
              </label>
              <Dropdown
                id="state"
                value={formData.state}
                options={stateOptions}
                onChange={(e) => handleInputChange('state', e.value)}
                placeholder="Select state"
                style={{ width: '100%' }}
                disabled={loading}
                filter
                filterBy="label"
              />
            </div>
          </div>

          {/* Schedule Date and Time */}
          <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '1rem' }}>
            <div>
              <label 
                htmlFor="scheduleDate" 
                style={{ 
                  display: 'block', 
                  marginBottom: '0.5rem', 
                  fontWeight: '500',
                  color: '#374151' 
                }}
              >
                Schedule Date <span style={{ color: '#ef4444' }}>*</span>
              </label>
              <Calendar
                id="scheduleDate"
                value={formData.scheduleDate}
                onChange={(e) => handleInputChange('scheduleDate', e.value)}
                placeholder="Select date"
                style={{ width: '100%' }}
                disabled={loading}
                minDate={new Date()}
                dateFormat="yy-mm-dd"
                showIcon
              />
            </div>

            <div>
              <label 
                htmlFor="scheduleTime" 
                style={{ 
                  display: 'block', 
                  marginBottom: '0.5rem', 
                  fontWeight: '500',
                  color: '#374151' 
                }}
              >
                Schedule Time <span style={{ color: '#ef4444' }}>*</span>
              </label>
              <Calendar
                id="scheduleTime"
                value={formData.scheduleTime}
                onChange={(e) => handleInputChange('scheduleTime', e.value)}
                placeholder="Select time"
                style={{ width: '100%' }}
                disabled={loading}
                timeOnly
                showTime
                hourFormat="24"
                showIcon
              />
            </div>
          </div>

          {/* Phlebotomist */}
          <div>
            <label 
              htmlFor="phleboId" 
              style={{ 
                display: 'block', 
                marginBottom: '0.5rem', 
                fontWeight: '500',
                color: '#374151' 
              }}
            >
              Phlebotomist <span style={{ color: '#ef4444' }}>*</span>
            </label>
            
            {phleboLoading ? (
              <div style={{ 
                display: 'flex', 
                alignItems: 'center', 
                padding: '0.75rem',
                border: '1px solid #d1d5db',
                borderRadius: '0.375rem'
              }}>
                <ProgressSpinner style={{ width: '20px', height: '20px' }} />
                <span style={{ marginLeft: '0.5rem' }}>Loading phlebotomists...</span>
              </div>
            ) : (
              <Dropdown
                id="phleboId"
                value={formData.phleboId}
                options={phleboList}
                onChange={(e) => handleInputChange('phleboId', e.value)}
                placeholder="Choose Phlebotomist"
                style={{ width: '100%' }}
                disabled={loading}
                filter
                filterBy="label"
              />
            )}
              {error && (
          <Message 
            severity="error" 
            text={error} 
            style={{ marginBottom: '1rem', width: '100%',marginTop:"1rem" }} 
          />
        )}

        {success && (
          <Message 
            severity="success" 
            text={success} 
            style={{ marginBottom: '1rem', width: '100%' }} 
          />
        )}
           
          </div>
        </div>
      </div>
    </Dialog>
     <ToastContainer
            position="top-right"
            autoClose={3000}
            hideProgressBar={false}
            newestOnTop={false}
            closeOnClick
            rtl={false}
            pauseOnFocusLoss
            draggable
            pauseOnHover
            theme="light"
        />
    </>
  );
}

export default EnquiryModal;